import { Button, Group, Stack, Text } from '@mantine/core';
import { closeAllModals } from '@mantine/modals';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FaqsItemRemoveProps {
  datasetId: string;
  faqsIds: string[];
  onDelete?: (params: { datasetId: string; faqsIds: string[] }) => Promise<void>;
}

export const FaqsItemRemove: FC<FaqsItemRemoveProps> = ({ datasetId, faqsIds, onDelete }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await onDelete?.({ datasetId, faqsIds });
    setLoading(false);
    handleCancel();
  };

  const handleCancel = () => {
    closeAllModals();
  };

  return (
    <div>
      <Stack gap="xs">
        <Text size="sm">{t('faqs.delete.confirm')}</Text>
        <Group justify="flex-end">
          <Button variant="outline" onClick={handleCancel}>
            {t('alert_cancel')}
          </Button>
          <Button color="red" loading={loading} onClick={handleDelete}>
            {t('delete_btn')}
          </Button>
        </Group>
      </Stack>
    </div>
  );
};
